module.exports = __webpack_public_path__ + "img/liveAlert.87530c7f.svg";